import Config from './config'

let publicConfigPromise

export const getPublicConfig = async () => {
  if (!publicConfigPromise)
  {
    publicConfigPromise = fetch(`${Config.getConfig('adminApi')}public-config`)
      .then(response => {
        if (!response.ok)
        {
          throw new Error(`Public config request failed: ${response.status}`)
        }

        return response.json()
      })
      .catch(err => {
        publicConfigPromise = null
        throw err
      })
  }

  return publicConfigPromise
}

export const getTenantLogoDataUrl = async () => {
  let publicConfig = await getPublicConfig()

  return publicConfig.logoDataUrl
}
